import React from 'react';
import { ShieldCheck, Zap, Sparkles } from 'lucide-react';
import './Features.css';

const Features = () => {
  const features = [
    {
      icon: ShieldCheck,
      gradient: 'linear-gradient(135deg, #9C4DF4 0%, #7C3AED 100%)',
      title: 'Safe to Speak',
      description: 'Quantify psychological safety with AI that understands the nuance behind employee feedback.'
    },
    {
      icon: Zap,
      gradient: 'linear-gradient(135deg, #10B981 0%, #059669 100%)',
      title: 'Velocity Drivers',
      description: 'Pinpoint exactly where misaligned goals are slowing down your shipping velocity.'
    },
    {
      icon: Sparkles,
      gradient: 'linear-gradient(135deg, #9C4DF4 0%, #3B82F6 100%)',
      title: 'AI Transformation',
      description: 'Receive a bespoke cultural roadmap generated by our enterprise-grade intelligence engine.'
    }
  ];

  return (
    <section id="services" className="features section">
      <div className="container">
        <div className="features-header">
          <h2 className="section-title">The Enculture Difference: Data-Driven Insights</h2>
          <p className="section-description">
            Move beyond assumptions and gut feelings. Enculture leverages an innovative, concise survey to gather critical data, providing you with a clear, objective picture of your culture's health.
          </p>
        </div>
        
        <div className="features-grid">
          {features.map((feature, index) => {
            const IconComponent = feature.icon;
            return (
              <div key={index} className="feature-card">
                <div className="feature-icon" style={{ background: feature.gradient }}>
                  <IconComponent size={28} strokeWidth={2.5} />
                </div>
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-description">{feature.description}</p>
              </div>
            );
          })}
        </div>
        
        <div className="features-cta">
          <div className="hero-buttons">
            <a
              href="https://calendly.com/enculture-demo/30min"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary"
            >
              Talk to a Culture Strategist
            </a>
          </div>
          <p className="features-cta__subtext">
            See how our platform turns culture data into clear insights for better people decisions.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Features;
